export default __webpack_public_path__ + "static/media/stomach.d5bf773d.png";